import { Component } from '@angular/core';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { Location } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { PartnerAnalysisGroup2 } from 'src/app/assabil-kernel/models/entities/control-tables/partner-analysis-group2';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { PartnerAnalysisGroup2Request } from 'src/app/assabil-kernel/models/dtos/control-tables/partner-analysis-group2-request';

@Component({
  selector: 'app-partner-analysis-group2-list',
  templateUrl: './partner-analysis-group2-list.component.html',
  styleUrls: ['./partner-analysis-group2-list.component.scss']
})
export class PartnerAnalysisGroup2ListComponent extends BasePage2<PartnerAnalysisGroup2> {

  // Filter fields
  // ---------------------------------------------------
  code: string;
  name: string;
  // ---------------------------------------------------
      
  // ---------------------------------------------------
  partnersAnalysisGroups: PartnerAnalysisGroup2[] = [];
  // ---------------------------------------------------
  

  constructor(
      protected toastr            : ToastrService,
      protected controlService    : ControlTablesService,
      protected router            : Router,
      protected baseService       : BaseService,
      protected leanUtilsService  : LeanUtilsService,
      protected location          : Location) {
      super(toastr, router, baseService, leanUtilsService, location);

      this.entityName = 'partnerAnalysisGroup2';
  }



  listFields = [
      { prop: 'partnerAnalysisGroup2Code', name: 'Code',  insertOnly : true},
      { prop: 'name', name: 'Name' },
      { prop: 'rank', name: 'Rang' }
  ]

  getRows(): PartnerAnalysisGroup2[] {
      return this.partnersAnalysisGroups;
  }

//----------------------------------------------------------------------
saveRow(partnerAnalysisGroup2: PartnerAnalysisGroup2): Promise<PartnerAnalysisGroup2> {
  let request  : PartnerAnalysisGroup2Request = new PartnerAnalysisGroup2Request(this.controlService.getUserInfo());
  request.partnerAnalysisGroup2 = partnerAnalysisGroup2;
    return this.controlService.save(this.entityName, request);
}
//----------------------------------------------------------------------

  //----------------------------------------------------------------------
  new(){
    let entity : PartnerAnalysisGroup2 = new PartnerAnalysisGroup2();
    entity.inserted = true;
    entity.edit = true;
    this.partnersAnalysisGroups.push(entity);
    this.partnersAnalysisGroups = [...this.partnersAnalysisGroups];
    }
//----------------------------------------------------------------------

  loadData() {
    let request         : BaseRequest = this.controlService.getRequest();
    request.strArg1 = this.code;
    request.strArg2 = this.name;

    this.controlService.getList(this.entityName, request).then(result => {
        this.partnersAnalysisGroups = result;
        
    }).catch(error => {
        this.showError(error);
    })
  }

  }
